import { render, staticRenderFns } from "./NetDistributionChart.vue?vue&type=template&id=64f30d82&scoped=true&"
import script from "./NetDistributionChart.vue?vue&type=script&lang=js&"
export * from "./NetDistributionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f30d82",
  null
  
)

export default component.exports